/**
 * DD-3662 Marketplace discovery: a lab's profile texts per language and its supplier
 * profile (what it offers other labs, and whether it is listed in the supplier browser).
 */

export type ProfileLanguage = 'sv' | 'en' | 'no' | 'da' | 'fi' | 'de' | 'nl' | 'pl';

/** The languages a profile can be written in, labelled in their own language. */
export const PROFILE_LANGUAGES: { code: ProfileLanguage; label: string }[] = [
    { code: 'sv', label: 'Svenska' },
    { code: 'en', label: 'English' },
    { code: 'no', label: 'Norsk' },
    { code: 'da', label: 'Dansk' },
    { code: 'fi', label: 'Suomi' },
    { code: 'de', label: 'Deutsch' },
    { code: 'nl', label: 'Nederlands' },
    { code: 'pl', label: 'Polski' },
];

/** A user locale ('sv_SE', 'en_US', …) as a profile language. */
export const profileLanguageOfLocale = (locale?: string): ProfileLanguage | undefined =>
    PROFILE_LANGUAGES.find((language) => language.code === locale?.split('_')[0])?.code;

/** DD-3695: the ten service categories a lab can offer as a supplier. */
export enum SupplierService {
    CAD = 'CAD',
    MILLING = 'MILLING',
    PRINTING_3D = 'PRINTING_3D',
    METAL = 'METAL',
    CERAMICS_FINISHING = 'CERAMICS_FINISHING',
    FIXED = 'FIXED',
    IMPLANT = 'IMPLANT',
    REMOVABLE = 'REMOVABLE',
    ORTHODONTICS_SPLINTS = 'ORTHODONTICS_SPLINTS',
    OTHER = 'OTHER',
}

/** The services in the order they are shown, in the profile and in Find suppliers. */
export const SUPPLIER_SERVICES = Object.values(SupplierService);

export type ProfileText = {
    language: ProfileLanguage;
    shortDescription?: string | null;
    longDescription?: string | null;
};

export type SupplierProfileText = {
    language: ProfileLanguage;
    description?: string | null;
};

export type SupplierProfile = {
    visible: boolean;
    services: SupplierService[];
    otherService?: string | null;
    texts: SupplierProfileText[];
};
